import React from "react";

export default function ActivityTimelineValue(props) {
    return (
        <div {...props} className="self-stretch">
            <span className="text-[#222222] text-base font-semibold font-['Poppins'] leading-normal">{props.title} :</span>
            <span className="text-[#222222] text-base font-normal font-['Poppins'] leading-normal"> {props.value}</span>
        </div>
    )
}